import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex, Box } from 'reflexbox'
import { Card } from 'react-toolbox/lib/card'

import UserApprovedCard from './UserApprovedCard'
import UserPendingCard from './UserPendingCard'
import PanelSectionHeader from 'components/fulcrum/panelSectionHeader/PanelSectionHeader'
import PanelSection from 'components/fulcrum/panelSection/PanelSection'
import progressBarHoc from 'containers/Async/AsyncProgressBar'

import {
  FETCH_APPROVERS,
  FETCH_APPROVER_IMAGE,
} from './constants'
import {
  approversSelector,
} from './selectors'
import {
  fetchApprovers,
} from './actions'
import {
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

import styles from './styles.scss'

const mapStateToProps = state => {
  return {
    approvers: approversSelector(state),
    currentApproval: currentApprovalSelector(state),
  }
}

const ProgressBar = progressBarHoc([
  FETCH_APPROVERS,
  FETCH_APPROVER_IMAGE,
])

class ApproverSection extends Component {
  static propTypes = {
    approvers: PropTypes.array.isRequired,
  }

  static defaultProps = {
    approvers: [],
  }

  createApproverListItems(){
    return this.props.approvers.map( approver => {
      const {
        id,
        username,
        ...rest
      } = approver

      const card = (approver.image) ? (
        (approver.approvalDate) ?
          <UserApprovedCard {...rest}/> : <UserPendingCard {...rest}/>
      ) : null

      return (
        <Box key={id} pr={2}>
          {card}
        </Box>
      )
    })
  }

  render() {
    return (
      <PanelSection>
        <PanelSectionHeader label='Approvers Section'/>
        <Flex wrap justify='center' >
          { this.createApproverListItems() }
        </Flex>
        <ProgressBar/>
      </PanelSection>
    )
  }
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps)

const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ApproverSection)
